import { css } from 'styled-components';
import styled from 'styled-components';

import { ColorCircle, theme, breakpoints } from '@notino/react-styleguide';

import { COLOR_CIRCLE_SIZE } from './constants';

export const ShadesVariantsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

export const OffsetScrollDiv = styled.div`
  position: relative;
  top: -4rem;

  @media (min-width: ${breakpoints.md}) {
    top: -40vh;
  }
`;

export const AdditionalInfo = styled.span<{
  isOutOfStock: boolean;
  isSelected: boolean;
}>`
  color: ${theme.color.text.primary};
  margin-left: 0.75rem;

  opacity: ${({ isOutOfStock }) => (isOutOfStock ? '0.25' : '1')};

  ${theme.typography.labelRegular400}
  ${({ isSelected }) =>
    isSelected &&
    css`
      ${theme.typography.labelRegular}
    `};
`;

export const TagOrWatchdogWrapper = styled.div`
  margin-left: auto;
`;

export const WatchdogLink = styled.button`
  text-decoration: underline;
  white-space: nowrap;

  background: transparent;
  border: 0;
  ${theme.typography.bodyRegular}
`;

export const ColorCircleWrapper = styled.div<{ isSelected: boolean }>`
  border-radius: 4rem;

  ${({ isSelected }) => css`
    border: 2px solid
      ${isSelected ? theme.color.border.selected : 'transparent'};
  `}
`;

export const BorderedColorCircle = styled(ColorCircle)`
  min-height: ${COLOR_CIRCLE_SIZE}rem;
  min-width: ${COLOR_CIRCLE_SIZE}rem;
  overflow: hidden;
`;

export const Title = styled.h4`
  margin-left: 1rem;
  ${theme.typography.labelLarge};
`;

export const VariantListItem = styled.li`
  width: 100%;

  // override layout styles for li
  padding: 0;
  margin: 0;
  &::before {
    content: none;
    display: none;
  }
`;

export const Variant = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 1.25rem;

  color: ${theme.color.text.primary};

  &:hover {
    background: ${theme.color.background.disabled};
  }
`;

export const VariantListItemInfo = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1rem;
  position: relative;
`;

export const Tag = styled.small`
  color: ${theme.color.text.tertiary};
`;

export const ShadeListButton = styled.button`
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  margin: 0.75rem 0;

  ${theme.typography.bodyRegular}
  font-weight: bold;
  font-size: 0.9rem;
`;
